var _excluded = ["icon", "sizeSpace", "color", "emphasis", "transformIcon", "opacity"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import space from "../../../utils/space";
export var defaultProps = {
  emphasis: "high"
};
var StyledSvgAtm = styled.svg.withConfig({
  componentId: "sc-n1a3i1-0"
})(function (_ref) {
  var $sizeSpace = _ref.$sizeSpace,
    $color = _ref.$color,
    $emphasis = _ref.$emphasis,
    $onColor = _ref.$onColor,
    $transformIcon = _ref.$transformIcon,
    $opacity = _ref.$opacity,
    theme = _ref.theme;
  return css(["display:block;width:", ";height:", ";fill:", ";", " ", " ", " ", " & path{fill:", ";", "}"], space($sizeSpace), space($sizeSpace), $color ? getColor(theme, $color) : getIconColor(theme, $onColor, $emphasis), $transformIcon === "right" && css(["transform:rotate(90deg);"]), $transformIcon === "down" && css(["transform:rotate(180deg);"]), $transformIcon === "left" && css(["transform:rotate(270deg);"]), $opacity && css(["opacity:", ";"], $opacity), $color ? getColor(theme, $color) : getIconColor(theme, $onColor, $emphasis), $opacity ? css(["fill-opacity:", ";"], $opacity) : null);
});
function IconAtm(_ref2) {
  var icon = _ref2.icon,
    sizeSpace = _ref2.sizeSpace,
    color = _ref2.color,
    _ref2$emphasis = _ref2.emphasis,
    emphasis = _ref2$emphasis === void 0 ? defaultProps.emphasis : _ref2$emphasis,
    transformIcon = _ref2.transformIcon,
    opacity = _ref2.opacity,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledSvgAtm, _extends({
    $sizeSpace: sizeSpace,
    $color: color,
    $emphasis: emphasis,
    $onColor: onColor,
    $transformIcon: transformIcon,
    $opacity: opacity,
    as: icon
  }, restProps));
}
export default IconAtm;